import { Button, Group, Stack, Title } from '@mantine/core';
import { useForm } from '@mantine/form';

import { EnvironmentCountries, TransitGuarantee } from '@e-origin/shared';

import { MultiLangCodes, Select, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';
import { useSettings } from '@hooks/useSettings';

interface EditGuaranteeModalContentProps {
  guarantee: TransitGuarantee;
  onSave: (values: TransitGuarantee) => void;
  onClose: () => void;
}

const QUERY_TYPE_OPTIONS = [
  {
    value: '1',
    label: '1 - Usage only',
  },
  {
    value: '2',
    label: '2 - Exposure only',
  },
  {
    value: '3',
    label: '3 - Usage and exposure',
  },
  {
    value: '4',
    label: '4 - General information only (no usage & exposure)',
  },
];

export const EditTransitGuarantee: React.FC<EditGuaranteeModalContentProps> = ({ guarantee, onSave, onClose }) => {
  const { data: settings } = useSettings();
  const codelistSystems = useCodeListSystem({ isTransit: true });

  const form = useForm<TransitGuarantee>({
    initialValues: guarantee,
  });

  return (
    <>
      <Stack mb="sm">
        <MultiLangCodes {...form.getInputProps('type')} label="Type" system={codelistSystems} value={form.values.type} code="CL251" />
        <TextInput {...form.getInputProps('reference.grn')} label="GRN" value={form.values.reference.grn} />

        <TextInput {...form.getInputProps('reference.accessCode')} label="Access code" value={form.values.reference.accessCode} />
        <TextInput {...form.getInputProps('reference.amountToBeCovered')} label="Default guarantee amount" value={form.values.reference.amountToBeCovered} />
        <MultiLangCodes
          {...form.getInputProps('reference.currencyCode')}
          label="Currency"
          value={form.values.reference.currencyCode}
          code="CL048"
          system={codelistSystems}
        />
        {settings?.country === EnvironmentCountries.NL && (
          <>
            <Title order={5} fw="bold">
              Query parameters
            </Title>
            <Select
              {...form.getInputProps('queryIdentifier')}
              label="Query type"
              data={QUERY_TYPE_OPTIONS}
              value={form.values.queryIdentifier?.toString()}
              onChange={(value) => form.setFieldValue('queryIdentifier', value ? Number(value) : null)}
            />
            <TextInput {...form.getInputProps('ownerId')} label="Owner ID" value={form.values.ownerId} />
          </>
        )}
      </Stack>
      <Group justify="flex-end" mt="md">
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={() => onSave(form.values)} variant="filled">
          Save
        </Button>
      </Group>
    </>
  );
};
